import Cognito from '@/infra/utils/cognito';
import Cookies from 'js-cookie';
import CookieKeys from '../../const/CookieKeys';

/**
 * システムの actions
 */
const actions = {

  /**
   * エラーを表示します
   */
  showFatalError: ({ commit }, payload) => {
    commit('fatalError', { visible: true, code: payload.code, message: payload.message });
  },

  /**
   * * toastを表示します
   */
  showToast: ({ commit }, payload) => {
    commit('toast', { visible: true, type: payload.type, message: payload.message, link: payload.link });
    setTimeout(function() {
      commit('toast', { visible: false, code: payload.type, message: payload.message });
    }, 3000);
  },

  /**
   * スマートフォンのレイアウト表示用flagを指定する
   */
  isMobile: ({ commit }, payload) => {
    commit('isMobile', payload);
  },

  /**
   * スポット一覧にResultToolsを表示するフラグ (現在MapPageで使用)
   */
  setShowResultTools: ({ commit }, payload) => {
    commit('setShowResultTools', payload);
  },
  /**
   * サイトIDを保持する
   */
  setSiteId: ({ commit }, payload) => {
    commit('setSiteId', payload);
  },
  /**
   * カスタマイズデータを保持する
   */
  setCustomize: ({ commit }, payload) => {
    commit('setCustomize', payload);
  },
  /**
   * ログイン状態をチェックします。
   */
  isAuthenticated: async ({ commit, state }) => {
    if (state.customize.userType === 'cognito') {
      try {
        const authResult = await new Cognito().isAuthenticated();
        // Cookieがなくなっている場合は再設定
        if (!Cookies.get(CookieKeys.USER_ID_COOKIE_KEY) || !Cookies.get(CookieKeys.ID_TOKEN_COOKIE_KEY)) {
          Cookies.set(CookieKeys.USER_ID_COOKIE_KEY, authResult.idToken.payload['cognito:username']);
          Cookies.set(CookieKeys.ID_TOKEN_COOKIE_KEY, authResult.idToken.jwtToken);
          // ユーザーIDをセット
          commit('setUserId', authResult.idToken.payload['cognito:username']);
        }
        return true;
      } catch (e) {
        return false;
      }
    } else {
      return true;
    }
  },
  /**
   * 現在のページはログイン必須のページかどうか（カスタマイズ）
   */
  isPageRequiredLogin: async ({ commit, state }, payload) => {
    const pageName = payload;
    if (!pageName || pageName === 'ErrorPage' || pageName === 'RedirectPage') {
      // エラーページ・リダイレクトページは判定させない
      return false;
    }
    if (!state.customize.loginRequired || !state.customize.loginRequired.hasOwnProperty('pages')) {
      // デフォルトは全てのページ不要
      return false;
    } else {
      // カスタマイズデータあり
      return state.customize.loginRequired.pages.some((page) => pageName === page);
    }
  },
  /**
   * エラーダイアログ（強制サイトTOP遷移）表示フラグをセットします。
   */
  setPageAccessErrorDialog: ({ commit }, payload) => {
    commit('setPageAccessErrorDialog', payload);
  },
  /**
   * エラーダイアログ（強制サイトTOP遷移）内容をセットします。
   */
  setPageAccessErrorDialogContents: ({ commit }, payload) => {
    commit('setPageAccessErrorDialogContents', payload);
  },
  /**
   * ページのタイトルを取得します。
   * @param {*} payload ページ名
   * @returns ページのタイトル
   */
  getPageTitle: async ({ commit, state }, payload) => {
    return !state.customize.providesForNtj && state.customize.pagesTitle && state.customize.pagesTitle.some((item) => item.page === payload)
      ? state.customize.pagesTitle.find((item) => item.page === payload).title
      : '';
  },
  /**
   * canonicalURLを設定します。
   */
  setCanonical: async ({ commit }, payload) => {
    const isCanonical = !!document.querySelector('link[rel="canonical"]');
    const link = isCanonical ? document.querySelector('link[rel="canonical"]') : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', payload);
    if (!isCanonical) {
      document.head.appendChild(link);
    }
  },

  /**
   * 構造化データを設定します。
   */
  setStructuredData: ({ commit }, jsonLD) => {
    console.dir(jsonLD);
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLD);
    document.head.appendChild(script);
  },

  /**
   * 構造化データを削除します。
   */
  removeStructuredData: () => {
    const scriptTag = document.querySelector('script[type="application/ld+json"]');
    if (scriptTag) {
      scriptTag.remove();
    }
  },
  getUserId: ({ commit, state }) => {
    return state.customize.userType === 'cognito' ? state.userId : Cookies.get(CookieKeys.PLANNING_COM_SEQ);
  },
};

export { actions as default };
